<template>
	<div class="evaluation">
		<!-- header -->
		<!-- <div class="evaluation.block">
			<intellectual-header></intellectual-header>
		</div> -->
		<!-- 导航栏 -->
		<div class="evaluation.block">
			<intellectual-navigation  :isTrademark="isTrademark" @toggleTrademarks="toggleTrademarks"></intellectual-navigation>
		</div>
		<div class="evaluation.banner" data-aos="fade-right" @click="consultation">
			<img src="../assets/evalution/banner.png" alt="">
		</div>
		<div class="evaluation.block evaluation.interpretation">
			<div class="evaluation.container" data-aos="fade-up">
				<h2>什么是双软评估</h2>
				<ul>
					<li><img src="../assets/evalution/product-eva.png" alt=""></li>
					<li>
						<p><span><img src="../assets/evalution/icon-1.png" alt=""></span>"双软评估"是指软件产品评估和软件企业评估</p>
						<p><span><img src="../assets/evalution/icon-1.png" alt=""></span>
							"双软评估"需要由企业向当地软件行业协会递交相应的材料进行
							申请评估，通过审核评估并获得软件产品证书和软件企业证书。
						</p>
					</li>
					<li><img src="../assets/evalution/form-eva.png" alt=""></li>
				</ul>
			</div>
		</div>
		<div class="evaluation.benefit">
			<div class="evaluation.container" data-aos="fade-up">
				<h2>双软评估不得不说的几大好处</h2>
				<ul>
					<li>
						<span><img src="../assets/evalution/benefit-1.png" alt=""></span>
						<p> 可享受税收优惠政策：第一、二年免征企业所得税，第三年至第五年减半征收企业所得税。</p>
					</li>
					<li>
						<span><img src="../assets/evalution/benefit-2.png" alt=""></span>
						<p> 可享受税收优惠政策：第一、二年免征企业所得税，第三年至第五年减半征收企业所得税。</p>
					</li>
					<li>
						<span><img src="../assets/evalution/benefit-3.png" alt=""></span>
						<p> 可享受税收优惠政策：第一、二年免征企业所得税，第三年至第五年减半征收企业所得税。</p>
					</li>
					<li>
						<span><img src="../assets/evalution/benefit-4.png" alt=""></span>
						<p> 可享受税收优惠政策：第一、二年免征企业所得税，第三年至第五年减半征收企业所得税。</p>
					</li>
				</ul>
			</div>
		</div>
		<div class="evaluation.btn" @click="consultation" data-aos="fade-up"><img src="../assets/evalution/eva-btn-1.png" alt=""></div>
		<div class="evaluation.block evaluation.condition" data-aos="fade-up">
			<div class="evaluation.container">
				<h2>双软企业评估的基本条件</h2>
				<img src="../assets/evalution/eva-require.png" alt="">
				<div class="evaluation.condition.btn" @click="consultation"><img src="../assets/evalution/eva-btn-2.png" alt=""></div>
			</div>
		</div>

		<!-- footer -->
		<common-footer></common-footer>
		<consultation-modal :consultationShow="consultationShow" @closeConsultationEvent="closeConsultationEvent"></consultation-modal>
		
	</div>
</template>

<script>
	import IntellectualHeader from '../components/intellectual-header.vue'
	import IntellectualNavigation from '../components/intellectual-navigation.vue'
	import CommonFooter from "../components/common-footer.vue"
	import ConsultationModal from '../components/consultation-modal.vue'
  
	export default {
		components: {
			IntellectualHeader,
			IntellectualNavigation,
			CommonFooter,
			ConsultationModal,
			

		},
		data() {
			return {
				isTrademark:false,
				consultationShow: false,
				
			}
		},
		methods: {
			consultation() {
				this.consultationShow = true
			},
			closeConsultationEvent(val) {
				this.consultationShow = val
			},
			toggleTrademarks(val){
					this.isTrademark = val
			}
			
			
		}
	}
</script>

<style lang="scss">
	@include component(evaluation) {
		background: #FFFFFF;
		font-size: 16px;

		@include part(block) {
			min-width: $minWidth;
			padding: 0 25px;
			margin: 0 auto;
			width: 100%;
			color: #333333;
		}

		@include part(banner) {
			width: 100%;
			height: 420px;
			min-width: $minWidth;
			cursor: pointer;

			img {
				display: block;
				height: 100%;
				width: 100%;
				object-position: center;
				object-fit: cover;
			}
		}

		@include part(container) {
			width: 1200px;
			margin: 0 auto;
			position: relative;

			>h2 {
				margin: 0 auto;
				font-size: 30px;
				padding-top: 66px;
				padding-bottom: 14px;
				position: relative;
				font-weight: 400;

				&:before {
					content: '';
					width: 79px;
					height: 5px;
					background: #F47227;
					position: absolute;
					bottom: 0;
					left: calc((100% - 79px) / 2);
				}
			}

		}

		@include part(interpretation) {
			height: 410px;

			ul {
				margin-top: 28px;
				display: flex;
				justify-content: space-around;
				align-items: center;

				li {
					&:nth-child(2) {
						width: 400px;

						img {
							display: block;
						}

						p {
							width: 100%;
							position: relative;
							padding-left: 33px;
							text-align: left;
							line-height: 30px;

							span {
								display: inline-block;
								position: absolute;
								left: 0;
							}

							&:not(:nth-child(1)) {
								margin-top: 26px;
							}
						}
					}
				}

			}
		}

		@include part(benefit) {
			color: #333;
			background: url('../assets/evalution/eva-benefit-bg.jpg');
			height: 283px;

			h2 {
				padding-top: 47px;
				color: #fff;
			}

			ul {
				width: 100%;
				height: 283px;
				box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
				border-radius: 10px;
				background-color: #ffffff;
				position: absolute;
				top: 143px;
				left: 0;
				display: flex;
				justify-content: space-between;
				flex-wrap: wrap;
				padding: 30px 0;

				li {
					width: 50%;
					display: flex;
					justify-content: flex-start;
					align-items: center;
					padding-left: 61px;

					img {
						display: block;
					}

					p {
						padding-right: 101px;
						;
						text-align: left;
						margin-left: 23px;
						line-height: 30px;
					}

					&:nth-child(odd) {
						p {
							padding-right: 61px;
							;
						}
					}
				}

			}

		}

		@include part(condition) {
			h2 {
				padding-top: 60px;
			}

			img {
				margin-top: 60px;
				display: block;
			}

			@include part(btn) {
				margin-top: 46px;
				cursor: pointer;

				img {
					margin-top: 0;
				}
			}
		}

		@include part(btn) {
			padding-top: 161px;
			width: 1200px;
			margin: 0 auto;
			height: 260px;
			cursor: pointer;

			img {
				display: block;
			}

		}

	}
</style>
